import C from "./constants";
import preState from "./initialState";
import {combineReducers} from "redux";
import {hasAnswer, replaceQuestionKey} from "./helpers";

export const editing = (initialState = false, action) => {
    switch(action.type)
    {
        case C.UPDATE_EDITING:
            return action.payload;
        default:
            return initialState;
    }
}

export const questions = (initialState = [], action) => {
    switch(action.type)
    {
        case C.GET_QUESTIONS_FULFILLED:
            return action.payload;
        default:
            return initialState;
    }
}

export const errors = (initialState = {}, action) => {
    switch(action.type)
    {
        case C.UPDATE_ERRORS:

            //Server error
            if(action.payload.value == null && action.payload.key == null){
                return {...initialState, serverError: action.payload};
            }

            //temporary until endpoint returns array...
            let errors = {...initialState};

            if(action.payload.value === null)
            {
                delete errors[action.payload.key];
            }
            else
            {
                errors[action.payload.key] = action.payload.value;
            }

            return errors;
        default:
            return initialState;
    }
}

export const saving = (initialState = false, action) => {
    switch(action.type)
    {
        case C.UPDATE_SAVING:
            return action.payload;
        default: 
            return initialState;
    }
}

export const profile = (initialState = {}, action) => {

    
    switch(action.type)
    {
        case C.SAVE_PROFILE_FUFILLED:
        case C.UPDATE_PROFILE:

           let newProfileState = {...initialState.data};
           const newProfileDataFufilled = {...newProfileState.main, ...action.payload}
           newProfileState.main = newProfileDataFufilled;

            return {
                data: newProfileState, 
                loading: initialState.loading,
            }

        case C.UPDATE_USER_QUESTION_ANSWERS:
            const question = action.payload.question;
            let newQuestionState = {...initialState.data};
            let replaceQuestions = [...newQuestionState.main.questions];

            if(!hasAnswer(question, newQuestionState.main.questions))
            {
                replaceQuestions = replaceQuestions.concat(action.payload);
            }
            else
            {
                replaceQuestions = replaceQuestionKey(replaceQuestions,action.payload)
            }
            
            newQuestionState.main = {...newQuestionState.main, questions: replaceQuestions};
            return {
                data: newQuestionState, 
                loading: initialState.loading,
            }
        case C.TOGGLE_INTEREST:
            const i = initialState.data.main.interests.indexOf(action.payload.interest);
            const newState = {...initialState.data};
            const interests = [...newState.main.interests];
            if(i < 0){
                newState.main.interests = interests.concat(action.payload.interest);
            } else {
                newState.main.interests = [...interests.slice(0,i), ...interests.slice(i+1)];
            }
            return {
                data: newState, 
                loading: initialState.loading,
            }
        case C.GET_PROFILE_PENDING:
            return {
                data: initialState.data, 
                loading: true,
            };
        case C.GET_PROFILE_FULFILLED:
                return {
                    data: action.payload, 
                    loading: false,
                };
        case C.GET_PROFILE_REJECTED:
        let response = action.payload;

        const error  = response.error;
        if(error && error === 'Entity not found')
        {
            return {
                data: preState.profile.data,
                loading: false,
            }
        }
            return {
                data: {error: action.payload.message},
                loading: false,
            }
        default:
            return initialState;
    }
    
}

export const achievements = (initialState = {}, action) => {

    switch(action.type){
        case C.GET_ACHIEVEMENTS_PENDING:
            return {
                data: action.payload, 
                loading: true,
            };
        case C.GET_ACHIEVEMENTS_FULFILLED:
            return {
                data: action.payload, 
                loading: false,
            };
        default:
            return initialState;
    }
}

/*
    Use combine reducers to manage each key of state seperately 
*/

export default combineReducers({
    editing,
    profile,
    saving,
    achievements,
    errors,
    questions
})